var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeReference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11.002C20.7091 11.002 22.5 12.7928 22.5 15.002C22.4998 17.2109 20.709 19.002 18.5 19.002C17.8673 19.002 17.2691 18.8543 16.7373 18.5928L13.6211 21.709C13.2306 22.0993 12.5975 22.0992 12.207 21.709C11.8165 21.3185 11.8165 20.6845 12.207 20.2939L15.2158 17.2852C14.7648 16.6377 14.5001 15.8508 14.5 15.002C14.5 12.7928 16.2909 11.002 18.5 11.002ZM18.5 3.00195C19.0523 3.00195 19.5 3.44967 19.5 4.00195V8.74414C19.5 9.29643 19.0523 9.74414 18.5 9.74414C17.9477 9.74414 17.5 9.29643 17.5 8.74414V5.00195H12.5V17.002C12.4998 17.5541 12.0521 18.002 11.5 18.002H4.5C3.94785 18.002 3.50022 17.5541 3.5 17.002V4.00195C3.5 3.44967 3.94772 3.00195 4.5 3.00195H18.5ZM18.5 13.002C17.3954 13.002 16.5 13.8974 16.5 15.002C16.5002 16.1063 17.3956 17.002 18.5 17.002C19.6044 17.002 20.4998 16.1063 20.5 15.002C20.5 13.8974 19.6046 13.002 18.5 13.002ZM5.5 16.002H10.5V5.00195H5.5V16.002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeReference);
export default __webpack_public_path__ + "static/media/CodeReference.e2cc2412f17e3aeb4b1dae88499e91c3.svg";
export { ForwardRef as ReactComponent };